import WeightTable from './WeightTable'

export default WeightTable
